export default {
    activeLicence:null,
    licences: [],
    licenceEndorsementTypes:[]
}